module.exports = __webpack_public_path__ + "static/img/image033.6269168.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image033.png
// module id = H/2j
// module chunks = 1